/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */

/*
 * Footer used across all the pages
 */

/*
 * Footer used across all the pages
 */

import React, { Suspense, useEffect, useState, useRef } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import styled from "styled-components";
import { lazy } from "@loadable/component";
import styles from "./footerNew.module.css";
import axios from "axios";
import parser from "html-react-parser";
const Img = lazy(() => import("../Img"));

const FooterWrapper = styled.div`
@media (min-width:1380px){
  .container{
  max-width: 100%;
padding: 0 50px;
  }
  .awardsSecondCol.col-md-5.col-sm-12.col-12 {
    flex: 28%;
    max-width: 28%;
}
`;

const Footer = (props) => {
  const ref = useRef();
  const [isIntersecting, setIntersecting] = useState(false);
  const [footerInfoData, setFooterInfoData] = useState();

  useEffect(() => {
    /**
     * @author Prerna Dubey
     * @date 07/23/2023
     * The below function is used to fetch the swmc footer data which
     * is stored in master JSON in S3 bucket.
     * @returns JSON Object of the requested file
     */
    const fetchSWMCFooterInfo = async () => {
      try {
        await axios
          .get(process.env.REACT_APP_SWMC_FOOTET_INFO)
          .then((response) => {
            //console.log(response.data);
            setFooterInfoData(response.data);
            const observer = new IntersectionObserver(([entry]) => {
              if (entry.isIntersecting) {
                setIntersecting(entry.isIntersecting);
                observer.disconnect();
              }
            });
            observer.observe(ref.current);
            // Remove the observer as soon as the component is unmounted
            return () => {
              observer.disconnect();
            };
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (e) {
        console.log(e);
      }
    };

    fetchSWMCFooterInfo();
  }, []);
  const date = new Date();
  const currentYear = date.getFullYear();
  return (
    <FooterWrapper>
      <div>
        <footer>
          {footerInfoData ? (
            <>
              <Container>
                <Row>
                  <Col
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className={styles.desctypo}
                  >
                    <div className={styles.logosize}>
                      <Suspense fallback={<div>Loading...</div>}>
                        <a
                          href={footerInfoData.sunWestLogoInfo.url}
                          target="_blank"
                          rel="noopener"
                          title={footerInfoData.sunWestLogoInfo.title}
                        >
                          <Img>
                            <img
                              src={footerInfoData.sunWestLogoInfo.imgPath}
                              alt={footerInfoData.sunWestLogoInfo.alt}
                              className={styles.footer_logo}
                              loading="lazy"
                            />
                          </Img>
                        </a>
                      </Suspense>
                    </div>
                    <br />
                    <div className={styles.footer_desc_text}>
                      <p>
                        <b>{parser(footerInfoData.disclaimer)}</b>
                      </p>
                    </div>
                  </Col>
                  <Col
                    md={{ span: 6, offset: 0 }}
                    lg={6}
                    sm={12}
                    xs={12}
                    className={styles.contactus}
                  >
                    <div className={styles.contact_block}>
                      <h4>{parser(footerInfoData.contactUs.heading)}</h4>

                      <div className={styles.ul_footer}>
                        <div style={{ display: "flex" }}>
                          <Suspense fallback={<div>Loading...</div>}>
                            <Img>
                              <img
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  marginTop: "4px",
                                }}
                                src={footerInfoData.contactUs.address.imgPath}
                                alt={footerInfoData.contactUs.address.alt}
                              />
                            </Img>
                          </Suspense>
                          <p>
                            <a
                              style={{ color: "#fff" }}
                              target="_blank"
                              href={
                                footerInfoData.contactUs.address.googleMapsUrl
                              }
                              rel="noreferrer"
                            >
                              {footerInfoData.contactUs.address.fullAddress}
                            </a>
                          </p>
                        </div>
                        <div className={styles.contactOptions}>
                          <div style={{ display: "flex" }}>
                            <Suspense fallback={<div>Loading...</div>}>
                              <Img>
                                <img
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    marginTop: "4px",
                                  }}
                                  src={footerInfoData.contactUs.phone.imgPath}
                                  alt={footerInfoData.contactUs.phone.alt}
                                />
                              </Img>
                            </Suspense>
                            <p>
                              <a
                                href={
                                  "tel:" +
                                  footerInfoData.contactUs.phone
                                    .swmcPhoneNumberWithIntlCode
                                }
                                style={{ color: "#fff" }}
                              >
                                {footerInfoData.contactUs.phone.swmcPhoneNumber}
                              </a>
                            </p>
                          </div>
                          <div className={styles.email}>
                            <Suspense fallback={<div>Loading...</div>}>
                              <Img>
                                <img
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    marginTop: "4px",
                                  }}
                                  src={footerInfoData.contactUs.email.imgPath}
                                  alt={footerInfoData.contactUs.email.alt}
                                />
                              </Img>
                            </Suspense>
                            <p>
                              <a
                                href={
                                  "mailto:" +
                                  footerInfoData.contactUs.email.email
                                }
                                style={{ color: "#fff" }}
                              >
                                {footerInfoData.contactUs.email.email}
                              </a>
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className={styles.social_footer}>
                        {footerInfoData.connectWithUs.socialMediaLinks.map(
                          (socialMediaLinksData, i) => (
                            <a
                              key={i}
                              href={socialMediaLinksData.url}
                              target="_blank"
                              rel="noopener"
                              title={socialMediaLinksData.title}
                            >
                              <Suspense fallback={<div>Loading...</div>}>
                                <Img>
                                  <img
                                    style={{
                                      margin: "15px 10px 10px 10px",
                                      width: "30px",
                                    }}
                                    src={socialMediaLinksData.imgPath}
                                    alt={socialMediaLinksData.alt}
                                  />
                                </Img>
                              </Suspense>
                            </a>
                          )
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>

                <div className={styles.awardrow}>
                  <div className={styles.top50Div}>
                    <Suspense fallback={<div>Loading...</div>}>
                      <Img>
                        <img
                          src={
                            footerInfoData.companyAwards.mortgageExecutiveTop50
                              .imgPath
                          }
                          className={styles.top50}
                          alt={
                            footerInfoData.companyAwards.mortgageExecutiveTop50
                              .alt
                          }
                          title={
                            footerInfoData.companyAwards.mortgageExecutiveTop50
                              .title
                          }
                          loading="lazy"
                        />
                      </Img>
                    </Suspense>
                  </div>

                  <div>
                    <div className={styles.memberBbb}>
                      <Suspense fallback={<div>Loading...</div>}>
                        <Img>
                          <a
                            href={footerInfoData.companyAwards.bbbRating.url}
                            target="_blank"
                            rel="noopener"
                            title={footerInfoData.companyAwards.bbbRating.title}
                          >
                            <img
                              src={
                                footerInfoData.companyAwards.bbbRating.imgPath
                              }
                              className={styles.bbbIcon}
                              alt={footerInfoData.companyAwards.bbbRating.alt}
                              loading="lazy"
                            />
                          </a>
                        </Img>
                      </Suspense>

                      <Suspense fallback={<div>Loading...</div>}>
                        <Img>
                          <a
                            href={footerInfoData.companyAwards.bcaRating.url}
                            target="_blank"
                            rel="noopener"
                            title={footerInfoData.companyAwards.bcaRating.title}
                          >
                            <img
                              src={
                                footerInfoData.companyAwards.bcaRating.imgPath
                              }
                              className={styles.memberIcon}
                              alt={footerInfoData.companyAwards.bcaRating.alt}
                              loading="lazy"
                            />
                          </a>
                        </Img>
                      </Suspense>
                    </div>
                    <a
                      href={footerInfoData.companyAwards.autismHeroes.url}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={footerInfoData.companyAwards.autismHeroes.imgPath}
                        title={footerInfoData.companyAwards.autismHeroes.title}
                        alt={footerInfoData.companyAwards.autismHeroes.alt}
                        style={{ maxWidth: "100%", width: "300px" }}
                        className={styles.Taca}
                      />
                    </a>
                  </div>

                  <div className={styles.ehoBirdeye}>
                    <Suspense fallback={<div>Loading...</div>}>
                      <Img>
                        <img
                          src={
                            footerInfoData.companyAwards.equalHousingOpportunity
                              .imgPath
                          }
                          alt={
                            footerInfoData.companyAwards.equalHousingOpportunity
                              .alt
                          }
                          title={
                            footerInfoData.companyAwards.equalHousingOpportunity
                              .title
                          }
                          className={`${styles.homicon} img-fluid`}
                        />
                      </Img>
                    </Suspense>

                    <div>
                      <Suspense fallback={<div>Loading...</div>}>
                        <Img>
                          <a
                            href={
                              footerInfoData.companyAwards.birdEyeReviews.url
                            }
                            target="_blank"
                            rel="noreferrer"
                          >
                            <iframe
                              name="bfiframe"
                              title="birdeye"
                              className={styles.birdeyeIframe}
                              src={parser(
                                footerInfoData.companyAwards.birdEyeReviews
                                  .iframeUrl
                              )}
                              id="bfpublish"
                              scrolling="no"
                              style={{
                                borderWidth: "0px",
                                display: "block",
                                overflow: "hidden",
                                frameborder: "0",
                                height: "75px",
                              }}
                            />
                          </a>
                          <p
                            style={{ textAlign: "center" }}
                            className={styles.birdeye}
                          >
                            Powered by{" "}
                            <a
                              href={
                                footerInfoData.companyAwards.birdEyeReviews
                                  .poweredByUrl
                              }
                              target="_blank"
                              rel="noreferrer"
                            >
                              Birdeye
                            </a>
                          </p>
                        </Img>
                      </Suspense>
                    </div>
                  </div>
                  <div style={{ margin: "auto" }}>
                    <a
                      href={
                        footerInfoData.companyAwards.poweredByCelligence.url
                      }
                      target="_blank"
                      rel="noopener"
                      title={
                        footerInfoData.companyAwards.poweredByCelligence.title
                      }
                    >
                      <img
                        src={
                          footerInfoData.companyAwards.poweredByCelligence
                            .imgPath
                        }
                        style={{
                          maxWidth: "100%",
                          width: "300px",
                          marginTop: "20px",
                        }}
                        title="Powered by Celligence"
                        alt={
                          footerInfoData.companyAwards.poweredByCelligence.alt
                        }
                        loading="lazy"
                      />
                    </a>
                  </div>
                </div>
              </Container>

              <Container className={styles.footer_link_banner}>
                <Row className={styles.footcont}>
                  <Col
                    md={12}
                    sm={12}
                    lg={4}
                    xl={4}
                    className={`${styles.padleft0} ${styles.copyrighttxt}`}
                  >
                    <div><p className={`${styles.ul_footer} ${styles.footer_list}`}>
                      © {currentYear} Sun West Mortgage Company, Inc. All Rights
                      Reserved
                    </p></div>
                  </Col>
                  <Col
                    md={12}
                    sm={12}
                    lg={8}
                    xl={8}
                    className={
                      styles.padleft0 +
                      " " +
                      styles.padright0 +
                      " " +
                      styles.dislinks
                    }
                  >
                    <ul
                      className={
                        styles.ul_footer +
                        " " +
                        styles.footer_list +
                        " " +
                        styles.linklist
                      }
                    >
                      {footerInfoData.footerLinks.map((footerLinksData, j) =>
                        footerLinksData.name === "Ask Angel Ai" ? null : (
                          <li key={j}>
                            <a
                              href={footerLinksData.url}
                              style={{ color: "#fff" }}
                              title={footerLinksData.title}
                            >
                              {footerLinksData.name}
                            </a>
                          </li>
                        )
                      )}
                    </ul>
                  </Col>
                </Row>
              </Container>
            </>
          ) : (
            ""
          )}
        </footer>
      </div>
    </FooterWrapper>
  );
};

export default Footer;
